import { Moment } from 'moment';
import { convertTimeStampToMinutes } from './convertDateTime';
import { Shift } from '../../../types/app/asset.types';
import { hoursMinutesShowFormat } from '../../../types/core/date.types';

/**
 * Spočítá datum směny na základě zaslaného data.
 * @param today datum, ke kterému se výpočet vztahuje
 * @param shift směna, jejíž datum chceme spočítat
 * @param subOneDay parametr se nastavuje na true, když chceme z výsledného data odečíst 1 day
 * @returns vrací začátek a konec jako datum a čas
 */
export const getFullShiftDateTime = (
  today: Moment,
  shift: Shift,
  isOneShift: boolean,
): { start: Moment | null; end: Moment | null } => {
  let start: Moment | null = null,
    end: Moment | null = null;
  const startMinutes = convertTimeStampToMinutes(shift.start);
  const endMinutes = convertTimeStampToMinutes(shift.end);

  if (today.format('HH:mm:ss') < shift.start) isOneShift = true;

  if (shift.start < shift.end) {
    start = today
      .clone()
      .startOf('day')
      .add(isOneShift ? -1 : 0, 'day')
      .add(startMinutes, 'minutes');
    end = today
      .clone()
      .startOf('day')
      .add(isOneShift ? -1 : 0, 'day')
      .add(endMinutes, 'minutes');
  } else if (today.format(hoursMinutesShowFormat) >= shift.start) {
    start = today.clone().startOf('day').add(startMinutes, 'minutes');
    end = today.clone().startOf('day').add(1, 'days').add(endMinutes, 'minutes');
  } else if (today.format(hoursMinutesShowFormat) < shift.start) {
    start = today.clone().startOf('day').add(-1, 'days').add(startMinutes, 'minutes');
    end = today.clone().startOf('day').add(endMinutes, 'minutes');
  }

  return {
    start,
    end,
  };
};

/**
 * Seznam směn v shifts chodí seřazený podle času - najdu index aktuální a směny a snížím o 1, pokud je index 0 beru poslední směnu z pole
 * @param currentShift aktuální směna, ke které se výpočet vztahuje
 * @param shifts seznam směn, ze kterých se vybírá předchozí
 * @returns předchozí směnu, pokud není žádná nalezena, vrátí current směnu
 */

export const getPreviousShift = (currentShift: Shift, shifts: Shift[]): Shift | null => {
  let currIndex = shifts.findIndex(
    (shift: Shift) => shift.start === currentShift.start && shift.end === currentShift.end,
  );
  if (currIndex === -1) return null;
  if (shifts.length === 1) return shifts[0];

  let prevShiftIndex = currIndex - 1 < 0 ? shifts.length - 1 : currIndex - 1;
  return shifts[prevShiftIndex];
};
